const getters = {
   returnTotalSwatchesPerComponent() {
      return({ tabSubgroup, activeComponent }) => {
        let swatchesCount = 0;
        tabSubgroup.forEach((subGroup) => {
          if(subGroup.components[activeComponent]) swatchesCount +=  subGroup.components[activeComponent].length;
        })
        return swatchesCount;
      };
    },
};

export default getters;
